import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { ManagementFileService } from '@core/services/entities/management-file.service';
import { ManagementFileResponseDto } from '@domain/management-file/dtos/management-file.response.dto';
import { ManagementFileRepository } from '@domain/management-file/repositories/management-file.repository';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ManagementFileRepositoryService
    implements ManagementFileRepository {
    constructor(private managementFileService: ManagementFileService) { }

    upload(request: FormData): Observable<ApiResponse<ManagementFileResponseDto>> {
        return this.managementFileService.upload(request);
    }

    show(request: RefId): Observable<ApiResponse<ManagementFileResponseDto>> {
        return this.managementFileService.show(request);
    }

    delete(request: RefId): Observable<ApiResponse<void>> {
        return this.managementFileService.delete(request);
    }

    download(request: RefId): Observable<ApiResponse<{ viewUrl: string }>> {
        return this.managementFileService.download(request);
    }
}